(() => {
  function initialize(container) {
    container.querySelectorAll('[data-ll-film]').forEach(card => {
      if (card.dataset.llFilmReady) return;
      card.dataset.llFilmReady = 'true';
      const details = card.querySelector('details');
      const video = card.querySelector('video');
      const label = card.querySelector('[data-ll-film-label]');
      const error = card.querySelector('[data-ll-film-error]');
      function message(text) { error.textContent = text; error.hidden = false; }
      details.addEventListener('toggle', () => {
        if (!details.open) {
          video.pause();
          label.textContent = label.dataset.watch;
          return;
        }
        label.textContent = 'Close film';
        if (!video.getAttribute('src')) {
          video.src = video.dataset.videoUrl;
          const track = video.querySelector('[data-captions-url]');
          if (track) track.src = track.dataset.captionsUrl;
        }
        video.hidden = false;
        error.hidden = true;
        document.querySelectorAll('[data-ll-film] video').forEach(other => {
          if (other !== video) other.pause();
        });
        const attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(() => {
          message('Use the video’s play control, or open the film below.');
        });
      });
      video.addEventListener('error', () => {
        message('The film could not load. You can open it below or continue your enquiry.');
      });
      window.addEventListener('pagehide', () => video.pause());
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), {once: true});
  } else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
